import { Directive, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, tap } from 'rxjs/operators';

import { ConfirmationDialogComponent } from '@assess/browser/common-ui';

import { HydraService } from './hydra.service';

@UntilDestroy()
@Directive({
  selector: '[assessHydra]',
})
export class HydraDirective implements OnInit {
  private matDialogRef: MatDialogRef<ConfirmationDialogComponent> | undefined;

  constructor(
    private readonly hydraService: HydraService,
    private readonly matDialog: MatDialog
  ) {}

  ngOnInit() {
    this.hydraService.onIdleStart$
      .pipe(
        untilDestroyed(this),
        tap(() => {
          this.matDialogRef = this.matDialog.open(ConfirmationDialogComponent, {
            data: {
              actionsVisible: false,
              title: 'Your session is about to expire!',
              message:
                'For your security, your session will expire shortly. Please resume activity if you wish to stay logged in.',
              confirmButtonLabel: 'Yes',
              cancelButtonLabel: 'No',
            },
            maxWidth: '400px',
          });
        })
      )
      .subscribe();

    this.hydraService.onIdleEnd$
      .pipe(
        untilDestroyed(this),
        filter(() => Boolean(this.matDialogRef)),
        tap(() => this.matDialogRef?.close())
      )
      .subscribe();
  }
}
